import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "../services/auth";

const Ctx = createContext({
  loading: true,
  user: null, // includes safeUser plus derived fields we add below
  refresh: async () => {},
});

export function AuthProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  async function refresh() {
    try {
      const r = await auth.me();
      // r = { safeUser, accountType, primaryOrg, orgs, plan, features }
      const safe = r?.safeUser ?? r ?? null;

      // Enrich the user object so the rest of the app can infer UX role
      // without rewriting every consumer. We keep original fields intact.
      const primaryOrgRole = r?.primaryOrg?.role ?? null; // "owner" | "admin" | "member" | "viewer" | null
      const enrichedUser = safe
        ? {
            ...safe,
            accountType: r?.accountType ?? null, // "individual" | "organization"
            primaryOrgRole, // org membership role if any
            orgs: r?.orgs ?? [],
            plan: r?.plan ?? null,
            features: r?.features ?? {},
            permsAllow: r?.permsAllow ?? [],
            permsDeny: r?.permsDeny ?? [],
          }
        : null;

      setUser(enrichedUser);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh();
  }, []);

  return (
    <Ctx.Provider value={{ loading, user, refresh }}>{children}</Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
